<div class="header">
  <div id="barra_istituzionale">

      <div class="row" style="margin-right: 0px; margin-left: 0px">
        <div class="logo">
          <a href="http://www.regione.lombardia.it">
            <img src="assets/images/logo.png" alt="Regione Lombardia">
          </a>
        </div>


        <div class="pull-right">
          <div class="area_titolo">
            <div id="manualeUtente" class="manualeUtente text-right" (click)="downloadManual()">Manuale Utente</div>
            <div class="titolo_esteso">Quadro Regionale degli Standard Professionali</div>
          </div>
        </div>

      </div>
  
  </div>



</div>